import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { RiMenuFold4Line, RiMenuUnfold4Line } from "react-icons/ri";
import { IoIosLink } from "react-icons/io";
import { MdAssignment } from "react-icons/md";
import "./SidebarReviewer.css";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import FooterReviewer from "./FooterReviewer.jsx";

const SidebarReviewer = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 640);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const isSmall = window.innerWidth <= 640;
      setIsMobile(isSmall);
      setIsSidebarOpen(!isSmall);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close sidebar on mobile when clicking outside
  useEffect(() => {
    if (!isMobile) return;

    const handleClickOutside = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobile]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Icon size logic (same as ANC)
  const getIconSize = () => {
    if (window.innerWidth <= 640) return 20;
    if (window.innerWidth <= 1024) return 21;
    return 22;
  };

  // Sync main content margin when sidebar opens/closes
useEffect(() => {
  if (isSidebarOpen) {
    // Sidebar OPEN → Wide content
    document.body.classList.remove("sidebar-collapsed-12ab");
  } else {
    // Sidebar CLOSED → Shrink content
    document.body.classList.add("sidebar-collapsed-12ab");
  }
}, [isSidebarOpen]);

  return (
    <>
      <div
        ref={sidebarRef}
        className={`sidebar-reviewer-main-12ab ${
          isMobile
            ? isSidebarOpen
              ? "sidebar-open-mobile-12ab"
              : "sidebar-close-mobile-12ab"
            : isSidebarOpen
            ? "sidebar-open-desktop-12ab"
            : "sidebar-close-desktop-12ab"
        }`}
      >
        {/* HEADER */}
        {isSidebarOpen && (
          <div className="sidebar-header-12ab">
            <span className="sidebar-menu-title-12ab">Menu</span>
            <button onClick={toggleSidebar}
            className="sidebar-collapsed-btn-12ab" >
              <RiMenuUnfold4Line
                size={getIconSize()}
                className="sidebar-toggle-icon-12ab1"
              />
            </button>
          </div>
        )}

        {/* COLLAPSE ICON WHEN CLOSED */}
        {!isSidebarOpen && (
          <button
            onClick={toggleSidebar}
            className="sidebar-collapsed-btn-12ab"
          >
            <RiMenuFold4Line
              size={getIconSize()}
              className="sidebar-toggle-icon-12ab1close"
            />
          </button>
        )}

        {/* LINKS */}
        {isSidebarOpen && (
          <ul className="sidebar-links-wrapper-12ab">
            <li>
              <NavLink
                to="/reviewer/pipelines/applicant"
                className={({ isActive }) =>
                  `sidebar-link-12ab ${isActive ? "sidebar-link-active-12ab" : ""}`
                }
              >
                <MdAssignment  className="sidebar-icon-12ab"  />
                <span className="ml-2">Assigned Application</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/reviewer/summary"
                className={({ isActive }) =>
                  `sidebar-link-12ab ${isActive ? "sidebar-link-active-12ab" : ""}`
                }
              >
                <IoCheckmarkDoneCircleOutline className="sidebar-icon-12ab" />
                <span className="ml-2">Reviewed Application</span>
              </NavLink>
            </li>
          </ul>
        )}

        {/* WHEN COLLAPSED → ICON-ONLY MENU */}
        {!isSidebarOpen && !isMobile && (
          <ul className="sidebar-collapsed-icons-12ab">
            <li>
              <NavLink
                to="/reviewer/pipelines/applicant"
                className={({ isActive }) =>
                  `sidebar-icon-link-12ab ${isActive ? "sidebar-icon-active-12ab" : ""}`
                }
                title="Assigned Application"
              >
                <IoIosLink className="sidebar-icon-only-12ab"  />
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/reviewer/summary"
                className={({ isActive }) =>
                  `sidebar-icon-link-12ab ${isActive ? "sidebar-icon-active-12ab" : ""}`
                }
                title="Reviewed Application"
              >
                <IoCheckmarkDoneCircleOutline className="sidebar-icon-only-12ab" size={22} />
              </NavLink>
            </li>
          </ul>
        )}
        
      </div>

      {/* MOBILE OVERLAY */}
      {isMobile && isSidebarOpen && (
        <div
          className="sidebar-overlay-mobile-12ab"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
      {/* FOOTER FIXED AT BOTTOM */}
{/* <div className="sidebar-footer-12ab"> */}
  <FooterReviewer />
{/* </div> */}

    </>
  );
};

export default SidebarReviewer;

  